import axios, { type InternalAxiosRequestConfig } from "axios";
import { useAuthStore, waitForHydration } from "../stores/auth-store";
import { refreshTokenNow } from "../lib/token-refresh";
import { ssoEnabled } from "../lib/sso-client";

interface RetryableRequestConfig extends InternalAxiosRequestConfig {
  _retry?: boolean;
}

export const adsHttpClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
});

adsHttpClient.interceptors.request.use(async (config) => {
  await waitForHydration();
  const { accessToken } = useAuthStore.getState();
  if (accessToken) {
    config.headers.set("Authorization", `Bearer ${accessToken}`);
  }
  return config;
});

adsHttpClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original: RetryableRequestConfig = error.config;
    if (error.response?.status === 401 && !original._retry && ssoEnabled) {
      original._retry = true;
      const success = await refreshTokenNow();
      if (success) {
        const { accessToken } = useAuthStore.getState();
        original.headers.set("Authorization", `Bearer ${accessToken}`);
        return adsHttpClient(original);
      }
      useAuthStore.getState().clearTokens();
      window.location.href = "/sso/login";
    }
    return Promise.reject(error);
  },
);
